import {
  Button as MantineButton,
  type ButtonProps as MantineButtonProps,
} from '@mantine/core';

export type ButtonVariant = 'primary' | 'secondary' | 'subtle' | 'ghost' | 'danger';

export interface ButtonProps extends Omit<MantineButtonProps, 'variant' | 'color' | 'loading'> {
  variant?: ButtonVariant;
  isLoading?: boolean;
}

const buttonTone: Record<ButtonVariant, Pick<MantineButtonProps, 'variant' | 'color'>> = {
  primary: { variant: 'filled', color: 'blue' },
  secondary: { variant: 'light', color: 'blue' },
  subtle: { variant: 'subtle', color: 'gray' },
  ghost: { variant: 'subtle', color: 'blue' },
  danger: { variant: 'filled', color: 'red' },
};

/**
 * Canonical action button.
 * One primary per context; danger for destructive/risky financial ops; loading keeps width via Mantine.
 */
export function Button({
  variant = 'primary',
  isLoading = false,
  children,
  ...props
}: ButtonProps & Record<string, unknown>) {
  return (
    <MantineButton loading={isLoading} {...buttonTone[variant]} {...props}>
      {children}
    </MantineButton>
  );
}
